import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import {
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Label,
  Input,
  ModalFooter,
  Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { BASE_URL, API, ESTADOS_OPORTUNIDAD } from 'CONST';
import { get } from 'helpers/requests';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MotivosRechazoModal = ({
  openModal,
  toggleModal,
  observacion,
  setObservacion,
  avanzarOportunidad,
  motivoRechazoId,
  setMotivoRechazoId,
  loading,
}) => {
  const [motivosRechazo, setMotivosRechazo] = useState([]);
  useEffect(() => {
    get(`${BASE_URL}${API.motivosRechazo}`).then((response) => {
      setMotivosRechazo(
        response.results.map((e) => ({
          value: e.id,
          label: e.descripcion,
        })),
      );
    });
  }, []);

  const onCloseModal = () => {
    setMotivoRechazoId(null);
    toggleModal();
  };

  return (
    <Modal
      isOpen={openModal}
      toggle={onCloseModal}
      type="modal-warning warning-container"
      style={{ maxWidth: '1100px', width: '80%' }}
    >
      <ModalHeader toggle={onCloseModal}>Rechazar Oportunidad</ModalHeader>
      <ModalBody>
        <Container>
          <Row style={{ marginBottom: '1rem' }}>
            <Col md="3">
              <Label> Motivo del Rechazo </Label>
            </Col>
            <Col>
              <Select
                name="motivos"
                options={motivosRechazo}
                onChange={(event) => setMotivoRechazoId(event.value)}
              />
            </Col>
          </Row>

          <Row>
            <Col md="3">
              <Label> Observaciones </Label>
            </Col>
            <Col>
              <Input
                id="observacion-info-inicial"
                type="textarea"
                value={observacion || ''}
                onChange={(event) => setObservacion(event.target.value)}
                rows="3"
              />
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          className="warning-cancel mr-auto no-bold"
          onClick={() => onCloseModal()}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          className="warning-accept no-bold"
          onClick={() => {
            avanzarOportunidad(
              'Se rechazó la oportunidad.',
              'No se pudo rechazar la oportunidad.',
              ESTADOS_OPORTUNIDAD.rechazado,
            );
          }}
          disabled={!motivoRechazoId || loading}
        >
          {loading ? <FontAwesomeIcon spin={loading} icon={faSpinner} /> : 'Rechazar Negocio'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

MotivosRechazoModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  observacion: PropTypes.string.isRequired,
  setObservacion: PropTypes.func.isRequired,
  avanzarOportunidad: PropTypes.func.isRequired,
  motivoRechazoId: PropTypes.number,
  setMotivoRechazoId: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

MotivosRechazoModal.defaultProps = {
  motivoRechazoId: null,
  loading: false,
};

MotivosRechazoModal.defaultProps = {};

export default MotivosRechazoModal;
